import { useTranslation } from 'react-i18next';
import { Mode, Text, Wrapper } from './SwitchAppMode.styled';
import { useDispatch, useSelector } from 'react-redux';
import { AppMode } from 'store/Common/reducers/common';
import { IRootReducerState } from 'store/store';
import { setAppMode } from 'store/Common/actions/common';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoutesConfig } from 'navigation/routes';

const SwitchAppMode = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const taxRate = searchParams.get('taxRate');
  const dispatch = useDispatch();
  const appMode: AppMode = useSelector(
    (state: IRootReducerState) => state.commonInfo.appMode
  );

  return (
    <Wrapper>
      <Mode
        onClick={() => dispatch(setAppMode(AppMode.BUYER))}
        active={appMode === AppMode.BUYER}
      >
        <Text>{t('Buyer')}</Text>
      </Mode>

      <Mode
        onClick={() => {
          dispatch(setAppMode(AppMode.SUPPLIER));
          if (taxRate != null) {
            navigate(RoutesConfig.SupplierOrders.fullPath);
          }
        }}
        active={appMode === AppMode.SUPPLIER}
      >
        <Text>{t('Supplier')}</Text>
      </Mode>
    </Wrapper>
  );
};

export default SwitchAppMode;
